
<template>
  <!-- eslint-disable vue/no-parsing-error -->
  <div style="min-height: 78.8vh;">
    <h2>升级到种子用户，享受更好的服务</h2>
    <p class="scentitle">更快 更高效的协作方案</p>
    <div class="flex-content" @click="onPay">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="item in shopList" :key="item.code">
          <div class="flex-content-card" :style="{opacity:item.enable? 1 : 0.6}">
                <!-- <Tag color="gold">疫情特别版</Tag> -->

            <Card bordered class="mycard">
              <div slot="title" class="card-hearder-content">
                <p class="card-title">{{item.goods_desc}}</p>
                <p class="card-price">{{item.goods_price_yuan}}</p>
                <p class="card-explain">元 / 年</p>
                <div class="card-btn-main">
                  <Button
                    type="primary"
                    size="small"
                    class="card-btn"
                    :data-code="item.code"
                    title="shopOne"
                    :disabled="!item.enable"
                  >购买</Button>
                </div>
                <Progress :percent="item.goods_reserve_percentage"  status="active"  hide-info v-show="item.enable" :stroke-color="['#ff9569','#e92758']" />

              </div>
              <div class="card-body" v-for="(list,index) in item.giveaway" :key="index">
                <span>{{ list }}</span>
                <Icon type="ios-checkmark" color="#2d8cf0" size="20" />
              </div>
            </Card>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination" v-show="showSwiperBtn"></div>
        <div class="swiper-button-prev " slot="button-prev" v-show="showSwiperBtn"></div>
        <div class="swiper-button-next " slot="button-next" v-show="showSwiperBtn"></div>
      </swiper>
      
    </div>
    
    
    <!-- <div class="flex-content" @click="onPay">
      <div class="flex-content-card" v-for="item in shopList" :key="item.code">
        <Card bordered class="mycard">
          <div slot="title">
            <p class="card-title">{{item.goods_desc}}</p>
            <p class="card-price">{{item.goods_price_yuan}}</p>
            <p class="card-explain">元 / 年</p>
            <div class="card-btn-main">
              <Button
                type="primary"
                size="small"
                class="card-btn"
                :data-code="item.code"
                title="shopOne"
              >购买</Button>
            </div>
          </div>
          <div class="card-body" v-for="(list,index) in item.giveaway" :key="index">
            <span>{{ list }}</span>
            <Icon type="ios-checkmark" color="#2d8cf0" size="20" />
          </div>
        </Card>
      </div>
    </div> -->

    <Modal v-model="modal" :title="modaltitle" @on-ok="ok" footer-hide>
      <p class="card-explain">请确认您购买的产品</p>
      <Card class="pay-content" dis-hover>
        <div slot="title">
          <p class="pay-title">{{shopItem.goods_desc}}</p>
          <p class="card-explain" style="color:#808695">{{shopItem.goods_price_desc}}</p>
        </div>
        <p class="pay-explain">{{shopItem.goods_body}}</p>
      </Card>
      <div class="pay-change">
        <p>支付方式</p>
        <RadioGroup v-model="payChange">
          <Radio label="微信" border>
            <i class="iconfont" style="color: #19c105;">&#xe650;</i>
            <span style="color: #19c105;">微信</span>
          </Radio>
          <Radio label="支付宝" border>
            <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
            <span style="color: #00aaee;">支付宝</span>
          </Radio>
        </RadioGroup>
      </div>
      <div class="agreement-content">
        我已认真阅读协议《
        <span class="agreement-user">用户协议</span> 》
      </div>
      <div class="pay-btn-content">
        合计：
        <span class="card-price">{{shopItem.goods_price_yuan}}</span>元
        <Button type="primary" class="pay-btn" @click="goPay">去支付</Button>
      </div>
    </Modal>

    <Modal v-model="modalCode" :title="modaltitle"  footer-hide>
      <div class="qr-code-content">
        <img :src="base64str" class="qr-code-img"></img>
        <div class="qr-code-content-btn">
          <Button type="dashed"  @click="isPay">支付未完成</Button>
          <Button type="primary"  @click="isPay">支付已完成</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="modalPay" :title="modaltitle"  footer-hide>
      <div class="qr-pay-content">
        <div class="qr-pay-content-icon">
          <Icon type="md-checkmark-circle" size="80" v-show="isToPay" color="#19be6b"/>
          <Icon type="md-close-circle" size="80" v-show="!isToPay" color="#ed4014" />
        </div>
        <div class="qr-pay-content-text">
          <span v-show="isToPay">恭喜您，支付成功</span>
          <span v-show="!isToPay">非常抱歉，支付失败</span>
        </div>
        <div class="qr-pay-content-btn">
          <Button type="primary"  @click="modalPay=false">确认</Button>
        </div>
      </div>
    </Modal>

  </div>
</template>
<script>
import ConstJson from '../../api/common/constjson'
let constJ = new ConstJson()
export default {
  data () {
    return {
      formItem: {
      },
      modalPay: false,
      isToPay: false,
      showSwiperBtn: false,
      order_pay_code: '',
      payChange: '微信',
      modal: false,
      modaltitle: '',
      shopItem: {},
      shopList: [],
      code: '',
      base64str:'',
      modalCode: false,
      swiperOption:{
        // loop:true,
        // loopFillGroupWithBlank:true,
        slidesPerView: 4,
        centerInsufficientSlides:true,
        spaceBetween: 20,
        slidesPerGroup : 4,
        disabledClass: 'my-button-disabled',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
      }
      
    }
  },
  mounted () {
  },
  created () {
    this.getShowList()
  },
  methods: {
    isPay () {
      constJ.getVXisPay({order_pay_code:this.order_pay_code}).then(resp => {
        console.log(resp)
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.isToPay = resp.data.success
            this.modalPay = true
            this.modalCode = false
          } else {
            this.$Message.error(resp.rltdesc);
          }
        } else {
          this.$Message.error(resp.rtndesc);
        }
      })
    },
    goPay () {
      let body = {
        trade_way: this.payChange === '微信' ? 'wxpay' : 'alipay',
        package_code: this.code
      }
      constJ.getVXqrCode(body).then(resp => {
        console.log(resp)
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.base64str = `data:image/jpg;base64,` + resp.data.data
            this.order_pay_code = resp.data.order_pay_code
            this.modal = false
            this.modalCode = true
          } else {
            this.$Message.error(resp.rltdesc);
          }
        } else {
          this.$Message.error(resp.rtndesc);
        }
      })
    },
    onPay (e) {
      console.log(e);
      if (e.target.nodeName.toLowerCase() === 'button' || e.target.parentNode.nodeName.toLowerCase() === 'button') {
        this.code = e.target.nodeName.toLowerCase() === 'button' ? e.target.dataset.code : e.target.parentNode.dataset.code
        //拿着code参数执行着相关的操作
        this.modal = true
        constJ.getShowItem(this.code).then(resp => {
          console.log(resp)
          if (resp.rtncode === 1) {
            if (resp.rltcode === 1) {
              this.modaltitle = `购买` + resp.data.goods_desc
              this.shopItem = resp.data
            } else {
              this.$Message.error(resp.rltdesc);
            }
          } else {
            this.$Message.error(resp.rtndesc);
          }
        })
      }
    },
    ok () {
      this.modal = false
    },
    getShowList () {
      constJ.getShowList().then(resp => {
        console.log(resp)
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.shopList = resp.data
            if(this.shopList.length > 4) {
              this.showSwiperBtn = true
            }else{
              this.showSwiperBtn = false
            }
          } else {
            this.$Message.error(resp.rltdesc);
          }
        } else {
          this.$Message.error(resp.rtndesc);
        }
      })
    }

  }
}
</script>
<style scoped>
@font-face {
  font-family: 'iconfont'; /* project id 1804652 */
  src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
  src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
    url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}
.iconfont {
  font-size: 16px;
  font-family: 'iconfont';
  margin-right: 10px;
}
.my-button-disabled{
  opacity:0.1;
}
h2 {
  height: 75px;
  line-height: 100px;
  text-align: center;
}
.scentitle {
  font-size: 10px;
  color: #ccc;
  line-height: 50px;
  text-align: center;
}
.flex-content {
  display: flex;
  margin: 0 24.5%;
  justify-content: space-evenly;
}
/* .flex-content-card {
  width: 19%;
  min-width: 200px;
} */
.mycard {
  height: 550px;
}
.card-hearder-content{
  height: 160px;
}
.card-title {
  text-align: center;
  line-height: 50px;
  font-size: 17px;
  color: #2d8cf0;
  height: 50px;
}
.card-price {
  text-align: center;
  line-height: 25px;
  font-size: 28px;
  color: #2d8cf0;
  height: 25px;
}
.card-explain {
  text-align: center;
  line-height: 12px;
  font-size: 12px;
  height: 15px;
}
.card-btn-main {
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.card-body {
  display: flex;
  font-size: 10px;
  justify-content: space-between;
}
.pay-content {
  border: 1px solid #ccc;
  margin: 5% 15%;
  padding: 7% 5%;
  text-align: center;
}
.pay-title {
  font-size: 20px;
  color: #f55d54;
  height: 30px;
}
.pay-change {
  text-align: center;
}
.pay-explain {
  height: 90px;
  font-size: 10px;
  line-height: 20px;
  text-align: left;
  margin-top: 10px;
}
.agreement-content {
  margin-top: 30px;
  font-size: 10px;
  text-align: center;
}
.agreement-user {
  font-size: 10px;
  color: #4386f5;
  cursor: pointer;
}
.pay-btn-content {
  margin-top: 30px;
  text-align: right;
}
.pay-btn {
  margin-left: 20px;
}
.qr-code-content{
  text-align: center;
  height: 350px;
}
.qr-code-img{
  height: 256px;
  width: 256px;
  margin-bottom: 30px;
}
.qr-code-content-btn{
  display: flex;
  justify-content: space-evenly;
}
.swiper {
  width: 100%;
  height: 100%;
}
/* .swiper-slide {
  background-position: center;
  background-size: cover;
} */
.qr-pay-content{
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
   align-items: center;
}
.qr-pay-content-text{
  font-size: 18px;
}
.swiper-button-prev, .swiper-button-next {
  background-size: 15px;
}
</style>